import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getPaymentListApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_PAYMENT_LIST,
            method: 'get',
            data: data,
        })
            .then((response) => { 
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 